import { capitalCase } from 'change-case';

import { handleResponseError } from '@/Helpers.js';
import Model from '@/models/Model.js';
import axios from '@/plugins/axios.js';

export default class EvaluationTemplate extends Model {
    static entity = 'evaluation_templates';

    static modelName = 'EvaluationTemplate';

    static fields() {
        return {
            id: this.attr(null),
            triggered_by: this.attr(null),
            survey_id: this.attr(null),
            subject_type: this.attr(null),
            enrollment_subject: this.attr(null),
            locked_after_seconds: this.attr(null),
            required_after_seconds: this.attr(null),
            is_anonymous: this.attr(null),
            time_limit: this.attr(null),
            course_codes_count: this.attr(null),

            courses: this.attr(null),

            ...super.fields(),

            survey: this.belongsTo('quizzes', 'survey_id'),
            course_codes: this.belongsToMany(
                'course-codes',
                'course_code_evaluation_template',
                'evaluation_template_id',
                'course_code_id'
            ),
        };
    }

    get locked_after_display() {
        if (this.locked_after_seconds === null) {
            return '';
        }

        if (this.locked_after_seconds === 0) {
            return 'Immediately';
        }

        return this.fromSecondsToDisplay('locked_after_seconds');
    }

    get required_after_display() {
        if (this.required_after_seconds === null) {
            return '';
        }

        if (this.required_after_seconds === 0) {
            return 'Immediately';
        }

        return this.fromSecondsToDisplay('required_after_seconds');
    }

    get time_limit_display() {
        return this.fromSecondsToDisplay('time_limit');
    }

    get triggered_by_description() {
        return capitalCase(this.triggered_by);
    }

    get readable_subject() {
        if (this.enrollment_subject === 'App\\Models\\Course') {
            return 'Course';
        }

        return 'Miscellaneous';
    }

    get readable_trigger() {
        return capitalCase(this.triggered_by);
    }

    get readable_enrollment_subject() {
        if (!this.enrollment_subject) {
            return '';
        }

        return capitalCase(this.enrollment_subject);
    }

    async fetchAssociatedCourseCodeIds() {
        const { data } = await axios.get(`/api/evaluation-templates/${this.id}/course-codes?associated_ids_only=1`);

        return data.data;
    }

    async saveCourseCodes(courseCodes) {
        try {
            const { data } = await axios.post(
                `/api/evaluation-templates/${this.id}/course-codes`,
                {
                    course_code_ids: courseCodes.map(courseCode => courseCode.id),
                },
                { errorHandle: false }
            );

            await EvaluationTemplate.insert({ data: data.data });

            return data.data;
        } catch (error) {
            handleResponseError(error);

            throw error;
        }
    }

    toForm() {
        return {
            survey_id: this.survey_id,
            triggered_by: this.triggered_by,
            subject_type: this.subject_type,
            enrollment_subject: this.enrollment_subject,
            locked_after_seconds: this.locked_after_seconds,
            required_after_seconds: this.required_after_seconds,
            is_anonymous: this.is_anonymous,
            time_limit: this.time_limit,
        };
    }
}
